import { Component, Input, Output, EventEmitter } from '@angular/core';

@Component({
  selector: 'pop-ui-action-menu',
  standalone: true,
  imports: [],
  templateUrl: './action-menu.component.html',
  styleUrl: './action-menu.component.scss'
})
export class ActionMenuComponent {
  @Input() actionMenu: {name:string, label:string, active:boolean}[] = [];
  @Input() spinner: { src: string, alt: string } = { src: '', alt: '' };
  @Output() actionSelected = new EventEmitter<string>();

  onAction(actionName: string) {
    this.actionSelected.emit(actionName);
  }
}
